import { array, boolean, object } from "yup";
import PageBlock from "@page-js/Pages/Page/Editor/scripts/pageBlock";

export default class Carousel extends PageBlock {
  public getType(): string {
    return "slider";
  }

  protected init(): any {
    return {
      props: {
        title: "슬라이더",
        images: [],
        options: {
          autoplay: false,
        },
      },
      attrs: {},
    };
  }

  public validateOrThrow(): Promise<any> {
    const schema = object().shape({
      props: object()
        .shape({
          options: object()
            .shape({
              autoplay: boolean().nullable().label("자동 재생"),
            })
            .label("슬라이더 설정"),
          images: array().min(1).required().label("이미지 목록"),
        })
        .label("옵션"),
      attrs: object().required().label("속성"),
    });

    return schema.validate(this.toJSON(), { abortEarly: false });
  }
}
